import React from "react";

/**
 * React Component that will surround its children with a collapsible container
 */
export class PanelHeaderRightComponent extends React.Component {
  static displayName = "PanelHeaderRightComponent";

  render() {
    return <div>{this.props.children}</div>;
  }
}
